<script lang="ts">
	import AdaptiveImage from '@app/lib/components/AdaptiveImage.svelte';
	import { displayAllCategories } from '@app/utils/blog';
	import { getOptimizedCmsImageUrl } from '@app/utils/cms';
	import { urls } from '@app/urls';
	export let article;

	export let classNames = '';

	$: articleObjectImg = {
		img: getOptimizedCmsImageUrl(article.content?.imageHeader.filename, '430x260'),
		alt: article.content.imageHeader.alt,
		width: '430',
		height: '260'
	};
</script>

{#if article?.content?.title}
	<a
		class="rounded block bg-dashboardBg item min-h-[412px] mb-3 min-w-[285px] lg:min-w-full {classNames}"
		href=" {urls.BLOG.ARTICLE(article.slug)}"
	>
		<AdaptiveImage
			src={articleObjectImg}
			classNames="border-b-4 border-primary object-cover w-full rounded-t"
		/>

		<div class=" text-center pt-5 px-3">
			{#if article.content.categories}
				<p class="text-sm font-display text-primary uppercase">
					{displayAllCategories(article)}
				</p>
			{/if}

			<p class=" text-lg text-black line-clamp-3">
				{article.content.title}
			</p>
		</div>
	</a>
{/if}
